import React from 'react';
import RouteMap from '../../components/RouteMap';
import PlatformRoles from './components/PlatformRoles';
import EditRole from './components/EditRole';
import CreateRole from './components/CreateRole';
import CopyRole from './components/CopyRole';
import UpdateRole from './components/UpdateRole';
import SelectTeams from './components/SelectTeams';

const Roles = ({
  match,
  user,
  role,
}) => (
  <RouteMap
    routes={[
      { path: `${match.url}/`, exact: true, component: PlatformRoles },
      { path: `${match.url}/:id/:type/edit`, exact: true, component: EditRole },
      { path: `${match.url}/create`, exact: true, component: CreateRole },
      { path: `${match.url}/copy`, exact: true, component: CopyRole },
      { path: `${match.url}/copy/select`, exact: true, component: SelectTeams },
      { path: `${match.url}/update`, exact: true, component: UpdateRole },
    ]}
    roleProp={role}
    user={user}
  />
);

export default Roles;
